import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import { Card, CardContent } from '@eliadmin/core/src/components/ui/card';
import Link from '@eliadmin/core/src/components/link';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import type { PropsWithChildren, ReactNode } from 'react';

export type CategoryCardProps = {
  href: string;
  className?: { root?: string; content?: string };
};

export function CategoryCard(props: PropsWithChildren<CategoryCardProps>) {
  return (
    <Card
      asChild
      // TODO: fix secondary colors
      className={cn('h-[56px] hover:bg-secondary/80', 'ea-category-card', props.className?.root)}
      variant="outlined"
    >
      <Link
        href={props.href ?? '#'}
        className={cn('w-full', 'ea-category-card__link', props.className?.root)}
        prefetch={false}
      >
        <CardContent
          className={cn(
            'line-clamp-2 flex h-full w-full flex-row items-center gap-4 text-ellipsis p-3',
            'ea-category-card__content',
            props.className?.content,
          )}
        >
          {props.children}
        </CardContent>
      </Link>
    </Card>
  );
}

type CategoryCardImageProps = {
  url: string;
  alt?: string;
  className?: {
    root?: string;
    image?: string;
  };
};
export function CategoryCardImage(props: CategoryCardImageProps) {
  return (
    <div
      className={cn(
        'flex h-20 w-20 min-w-20 flex-shrink-0 items-center justify-center',
        'ea-category-card-image__root',
        props.className?.root,
      )}
    >
      <Image
        alt={resolveImageAlt(props, 'category-image')}
        src={props.url}
        width={192}
        height={192}
        sizes="192px"
        quality={90}
        className={cn(
          'max-h-20 w-20 object-contain',
          'ea-category-card-image__image',
          props.className?.image,
        )}
      />
    </div>
  );
}

export function CategoryCardName(props: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={cn('text-left text-sm font-bold', 'ea-category-card-name', props.className)}>
      <span>{props.children}</span>
    </div>
  );
}

export function CategoryCardDescription(props: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={cn(
        'line-clamp-5 break-normal pt-4 text-left text-xs [overflow-wrap:normal]',
        'ea-category-card-description',
        props.className,
      )}
    >
      <span>{props.children}</span>
    </div>
  );
}

export function CategoryCardArrow(props: { className?: string; icon?: ReactNode }) {
  return null;
}
